import { createSelector } from '@ngrx/store';
import { membersState } from '../root';

export const getMemberInterface = createSelector(membersState, (members) => members.memberInterface);
